import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appAutoFocus]'
})
export class AutoFocusDirective {

  @Input('appAutoFocus') appAutofocus = false;

  constructor(private el: ElementRef) { }
 /* istanbul ignore next */
  public ngAfterContentInit() {
    setTimeout(() => {
      if (this.appAutofocus) {
        this.el.nativeElement.focus();
      }
    }, 0);
  }

}



import { HostBinding, Attribute } from '@angular/core';
import { IndexId } from '../models/Constants';

@Directive({
  selector: '[autoCompleteOff]',
})
export class AutocompleteOffDirective {

  @HostBinding('attr.autocomplete') auto;
   /* istanbul ignore next */
  constructor(private _el: ElementRef, @Attribute('autocomplete',) autocomplete: string) {
    this.auto = autocomplete || 'off';
    this._el.nativeElement.setAttribute('autocomplete', 'new-password' + Math.floor(Math.random() * IndexId));
    this._el.nativeElement.setAttribute('autocorrect', 'off');
    this._el.nativeElement.setAttribute('autocapitalize', 'none');
    this._el.nativeElement.setAttribute('spellcheck', 'false');
  }


}